/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgWalletSettlement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11 9.977a1.64 1.64 0 0 1 1.636-1.643h14.728A1.64 1.64 0 0 1 29 9.977V29.69a1.64 1.64 0 0 1-1.5 1.637c-.003-.844-.612-1.527-1.363-1.527-.754 0-1.364.686-1.364 1.533h-1.364c0-.847-.61-1.533-1.363-1.533s-1.364.686-1.364 1.533h-1.364c0-.847-.61-1.533-1.364-1.533-.753 0-1.363.686-1.363 1.533h-1.364c0-.847-.61-1.533-1.364-1.533-.751 0-1.36.683-1.363 1.527A1.64 1.64 0 0 1 11 29.69V9.977Zm15 3.774H14v-1.5h12v1.5Zm-12 3.5h12v-1.5H14v1.5Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgWalletSettlement)
export default Memo
